import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';
import ConfirmCancellationCta from './ConfirmCancellationCta';

export default injectIntl(withRouter(withUser(ConfirmCancellationCta)));
